"use client";

import Modal from "@/components/ui/modal";
import CustomEditorProvider from "@/providers/custom-editor-provider";
import { TCommunityEditPost } from "@/types/post";
import CreatePostForm from "./create-post-form-v2";

type TCreatePostProps = {
	open: boolean;
	defaultValues?: TCommunityEditPost;
	setOpen: (state: boolean) => void;
	mode?: "create" | "edit";
};

const CreatePostModal = ({ open, defaultValues, mode = "create", setOpen }: TCreatePostProps) => {
	const handleFormOnSubmit = (success: boolean) => {
		if (success) {
			setOpen(false);
		}
	};

	return (
		<Modal isOpen={open} onClose={() => setOpen(false)} className="max-w-4xl">
			<div className="mb-8 text-center">
				<h3 className="text-2xl font-bold md:text-3xl">
					{mode === "create" ? "Create a" : "Update"} Post
				</h3>
				<p className="mt-1 text-gray-500 md:text-lg">
					Ask a question to connect with your community
				</p>
			</div>

			<CustomEditorProvider>
				<CreatePostForm mode={mode} defaultValues={defaultValues} onSubmit={handleFormOnSubmit} />
			</CustomEditorProvider>
		</Modal>
	);
};

export default CreatePostModal;
